import { Features } from "@/store/features/features";
import { usePhoneViewerLayout } from "@/hooks/use-phone-viewer-layout";
import { selectHasFeature } from "@/store/features/features-slice";
import { useAppSelector } from "@/store/store-hooks";
import { selectCanUseAiIndexing } from "@/store/subscription-features/subscription-features-selectors";
import { ToolGroup } from "@faro-lotv/flat-ui";
import { useState, type JSX } from "react";
import { OverlayToolbar } from "../overlay-toolbar";
import { AiBoundingBoxToggle } from "./ai-bounding-box-toggle";
import { MultiSheetTool } from "./multi-sheet-tool";
import { TagsFilterTool } from "./tags-filter-tool";
import { ViewOptionsTool } from "./view-options-tool";

/** @returns a toolbar that contains the tools to manage view settings */
export function ViewSettingsToolbar(): JSX.Element | null {
  const isPhone = usePhoneViewerLayout();
  const [toolbarRef, setToolbarRef] = useState<HTMLDivElement | null>(null);

  const isAiChatFeatureEnabled = useAppSelector(
    selectHasFeature(Features.AiChat),
  );
  const canUseAiIndexing = useAppSelector(selectCanUseAiIndexing);
  const isAiChatAllowed = isAiChatFeatureEnabled && canUseAiIndexing;

  return (
    <OverlayToolbar
      ref={setToolbarRef}
      sx={[
        {
          alignSelf: isPhone ? "stretch" : "flex-end",
          mt: isPhone ? 0 : 6,
        },
        isPhone && {
          "& button": { width: "100%", minWidth: 48, minHeight: 48 },
          "& .MuiToggleButtonGroup-root": {
            width: "100%",
            display: "grid",
            gridAutoFlow: "column",
            gridAutoColumns: "minmax(0, 1fr)",
          },
          "& .MuiToggleButtonGroup-root > span": {
            display: "flex",
            minWidth: 0,
          },
        },
      ]}
      allowOverflow
    >
      <ToolGroup orientation={isPhone ? "horizontal" : "vertical"}>
        <ViewOptionsTool anchorEl={toolbarRef} />
        <TagsFilterTool anchorEl={toolbarRef} />
        <MultiSheetTool anchorEl={toolbarRef} />
        {isAiChatAllowed && <AiBoundingBoxToggle />}
      </ToolGroup>
    </OverlayToolbar>
  );
}
